
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { EmojiPicker } from "./EmojiPicker";

interface ChatInputProps {
  newMessage: string;
  setNewMessage: (message: string) => void;
  sendMessage: () => void;
  showEmojiPicker: boolean;
  setShowEmojiPicker: (show: boolean) => void;
  addEmoji: (emoji: string) => void;
  editingMessage: string | null;
  editText: string;
  setEditText: (text: string) => void;
  cancelEdit: () => void;
  saveEdit: (messageId: string | null) => void;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  newMessage,
  setNewMessage,
  sendMessage,
  showEmojiPicker,
  setShowEmojiPicker,
  addEmoji,
  editingMessage,
  editText,
  setEditText,
  cancelEdit,
  saveEdit
}) => {
  return (
    <div className="p-4 border-t">
      {editingMessage ? (
        // Editing mode
        <div className="space-y-2">
          <div className="text-sm text-gray-500 mb-1">Bericht bewerken</div>
          <Textarea 
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
            className="min-h-[60px] resize-none"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                saveEdit(editingMessage);
              }
            }}
          />
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={cancelEdit}>
              Annuleren
            </Button>
            <Button 
              onClick={() => saveEdit(editingMessage)}
              disabled={!editText.trim()}
            >
              Opslaan
            </Button>
          </div>
        </div>
      ) : (
        // Normal message mode
        <div className="flex gap-2">
          <Textarea 
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Typ een bericht..."
            className="min-h-[60px] resize-none"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                sendMessage();
              }
            }}
          />
          <div className="flex flex-col gap-2 self-end">
            <EmojiPicker 
              showEmojiPicker={showEmojiPicker}
              setShowEmojiPicker={setShowEmojiPicker}
              addEmoji={addEmoji}
            />
            <Button 
              onClick={sendMessage}
              disabled={!newMessage.trim()}
            >
              <Send className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
